import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import { SHOPS_LIST, ShopState } from '../shop-state';

export type ShopReducers = ShopState;

export function getReducers(): ActionReducerMap<ShopReducers> {
  return {
    shops: StateUtils.loaderReducer<Pos[]>(SHOPS_LIST),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<ShopReducers>> = new InjectionToken<
  ActionReducerMap<ShopReducers>
>('ShopReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
